import { render, staticRenderFns } from "./show-skeleton.vue?vue&type=template&id=6b828138&scoped=true&"
import script from "./show-skeleton.vue?vue&type=script&lang=js&"
export * from "./show-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./show-skeleton.vue?vue&type=style&index=0&id=6b828138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b828138",
  null
  
)

export default component.exports